var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme+' appContainer',attrs:{"id":"app"}},[_c('router-view'),(_vm.notifyAudio)?_c('audio',{ref:"messageAudio",attrs:{"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","autoplay":"","muted":""}},[_c('source',{attrs:{"src":_vm.notifyAudio}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }